import { InjectionToken } from '@angular/core';
import { CoreConfig } from '../models';

export const CORE_CONFIG_TOKEN = new InjectionToken<CoreConfig>('forRoot() Core Module Config');
